<template>
  <main>
    <wl-banner bgUrl='/static/img/product/sysaq/banner.png'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1">
      <article class="container">
        <wl-title title='实验室安全管理系统' :isNeedDesc=false class="wow fadeInUp" data-wow-duration="2s" data-wow-delay="0ms"></wl-title>
        <section class="flexWrap wow fadeInUp" data-wow-duration="3s" data-wow-delay="300ms">
          <a class="box" v-for="(item,index) in page1Data" :key="index" :href="item.path">
            <section class="img transImg">
              <img v-lazy="'/static/img/product/sysaq/'+(index+1)+'.png'" :alt="item.alt">
            </section>
            <h3>{{item.name}}</h3>
          </a>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
import WOW from 'wowjs'
export default {
  name: 'sysaqManageSystem',
  data() {
    return {
      page1Data: [
        { name: '危险化学品管理系统', path: '/product/hazardous' },
        { name: '仪器预约与共享管理平台', path: '/product/instrument' },
        { name: '实验室智能环境监测系统', path: '/product/monitor' },
        { name: '实验室安全教育考试准入系统', path: '/product/approve' },
        { name: '实验室安全检查系统', path: '/product/inspect' },
        { name: '生物样本库管理系统', path: '/product/sample' },
      ],
    }
  },
  mounted() {
    new WOW.WOW({ live: false }).init()
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
main {
  background: #fbfbff;
}
h3 {
  font-size: 24px;
  font-weight: 400;
  color: #262626;
  line-height: 24px;
  padding-bottom: 76px;
  padding-top: 34px;
}
.page1 {
  height: 958px;
  padding-top: 95px;
  overflow: hidden;
  .flexWrap {
    padding-top: 65px;
  }
  .box {
    width: 400px;
    .img {
      width: 400px;
      overflow: hidden;
      border-radius: 14px;
      img {
        transition: all 0.15s linear;
      }
    }
    &:hover {
      img {
        transform: scale(1.08);
      }
      h3 {
        color: #308dff;
      }
    }
  }
}
</style>
